(function (module) {
    'use strict';

    function UsersCtrl(User, Store, utils, $mdDialog) {
        this.$onInit = () => {
            this.utils = utils;
            // RESOLVE
            this.loading = true;

            User.find()
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.users = Store.setMultiModelData('users', response);

                });

            this.current = Store.getCurrentUser();
            this.orderBy = 'createdAt';
            
            console.log(this.current);
        };

        this.delete = () => {
            const ids = _.chain(this.users)
                .filter({selected: true})
                .map((item) => item.id)
                .value();


            const modalTitle = 'Are you sure you want to permanently remove selected users?';
            const modalConfirmText = 'Yes, remove';
            const modalCancelText = 'Cancel';

            const confirmActionFunc = (ids) => {
                const idsWithoutSelf = _.without(ids, Number(this.current.id));
                return User.destroyAll({
                    where: { id: { inq: idsWithoutSelf } },
                })
                    .$promise
                    .then(() => {
                        _.remove(this.users, (user) => _.indexOf(ids, user.id) >= 0);
                        this.selectAllCheckbox = false;
                    })
                    .catch((error) => {
                        console.error('error', error);
                    });
            };

            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: null,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    itemCount1: null,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(ids);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.selectAll = () => {
            this.filteredItems.forEach((user) => {
                if(Number(user.id) !== Number(this.current.id)) {
                    user.selected = this.selectAllCheckbox;
                }
            });
            this.updateSelectedCount();
        };

        this.updateSelectedCount = () => {
            this.selectedCount = _.chain(this.users).filter((user) => user.selected).size().value();
        };

        this.select = () => {
            this.updateSelectedCount();
        };
    }

    module
        .config(function ($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider
                .state('root.users', {
                    url: '/users',
                    data: {
                        pageTitle: 'USERS.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<users-list-component/>'
                        }
                    },
                    bodyClass: 'page--users'
                });

            $translatePartialLoaderProvider.addPart('/js/users');
        })

        .component('usersListComponent', {
            templateUrl: '/js/users/users.html',
            controller: UsersCtrl
        });

})(angular.module('rocket.components'));
